import { ITEM_TYPES } from '../types/ItemTypes';
export function getDefaultItemPayload() {
  return {
    itemType: ITEM_TYPES.STATIC_PAGE_V2,
    itemData: {},
    seoData: {},
    asNewPage: false
  };
}